import ajax from 'utils/request';
import {API_KEY_TYPES} from 'utils/const';
//获取用户app列表
export function getConsumptionApp() {
    return ajax('GET', '/clients/my/consumption-app').then(res=>{
        //处理数据
        const list = res.data.clients[0].apps.filter(item=>{
            return item.type === API_KEY_TYPES.NORMAL;
        });
        return list;
    });
}

//获取用量
export function getConsumptionByApp(params) {
    return ajax('POST', '/consumption-v2/by-app',params);
}

//获取印尼身份证用量
export function getKTPConsumptionByApp(params) {
    return ajax('POST', '/consumption-v2/by-app-ocrina',params);
}



// WEBPACK FOOTER //
// ./src/actions/consumption.js